import { makeSelector } from 'containers/app/selectors'

const timeFormat = (state) => state.getIn(['timeFormats', 'timeFormat'])

export const getTimeFormat = makeSelector(timeFormat)
